import { jsx as _jsx } from "react/jsx-runtime";
import { ExpirationStatus, IndexBackupTypes, IndexType, LicenseMonitoringLevel, ProductEdition, ProductName, ProductType } from '@coveo/platform-client';
import defaultsDeep from 'lodash.defaultsdeep';
import { useMemo } from 'react';
import { LicenseContext } from '../contexts/LicenseContext.js';
export var defaultTestLicense = {
    accountId: 'batman@waynecorp.com',
    accountName: 'Batman',
    department: 'WayneCorp R&D',
    expirationDate: 1610647025895,
    expirationStatus: ExpirationStatus.ACTIVE,
    productName: ProductName.COVEO_CLOUD,
    productType: ProductType.TRIAL,
    productEdition: ProductEdition.ENTERPRISE,
    indexBackupType: IndexBackupTypes.NONE,
    indexType: IndexType.COVEO,
    type: 'Enterprise',
    properties: {
        content: {
            onPremisesSourcesEnabled: true
        }
    },
    connectors: [],
    entitlements: [],
    monitoringLevel: LicenseMonitoringLevel.NO_MONITORING,
    machineLearningModels: {}
};
export var TestLicenseProvider = function TestLicenseProvider(param) {
    var children = param.children, license = param.license;
    var ctx = useMemo(function() {
        return defaultsDeep({}, license, defaultTestLicense);
    }, [
        license
    ]);
    return /*#__PURE__*/ _jsx(LicenseContext.Provider, {
        value: {
            query: {
                data: ctx,
                isLoading: false,
                isSuccess: true,
                isPending: false,
                isError: false,
                status: 'success'
            }
        },
        children: children
    });
};

//# sourceMappingURL=TestLicenseProvider.js.map